<template>
    <div class="experience-wrapper">
        <div class="experience-wrapper__title">
            Enhance your Ylands experience
        </div>
    </div>
</template>

<script>
export default {
    name: 'EnhanceExperience',
};
</script>

<style scoped lang="scss">
.experience-wrapper {
    position: relative;
    width: auto;
    height: 500px;
    overflow: hidden;
    background: $gray-light-sec;
    background: url('~Images/home/enhance_your_experience.jpg') no-repeat center
        center;
    background-size: cover;
    position: relative;
    display: flex;
    @media (max-width: $xm-up) {
        background: url('~Images/home/enhance_your_experience_1024.png')
            no-repeat center center;
    }
    @media (max-width: $sm-up) {
        height: 400px;
    }
    @media (max-width: $xs-up) {
        height: 300px;
        background: url('~Images/home/enhance_your_experience_500.png')
            no-repeat center center;
    }

    &__title {
        width: 90%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: $blue-main;
        font-family: $politica-font;
        font-size: 55px;
        font-weight: 800;
        letter-spacing: 2.5px;
        line-height: 60px;
        -webkit-text-fill-color: transparent;
        background: linear-gradient(270deg, #8cfbb6 0%, #f5ffa5 100%);
        -webkit-background-clip: text;

        @media (max-width: 425px) {
            font-size: 35px;
            font-weight: 700;
            letter-spacing: 1px;
            line-height: 50px;
        }
    }
}
</style>
